var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Clients',{key:_vm.currentSubPage,attrs:{"currentSubPage":_vm.currentSubPage}})}
var staticRenderFns = []

export { render, staticRenderFns }